// === Баннер согласия на диагностику (27.08.2026) ===
//
// Раньше сбор ошибок (с записью экрана при сбое) и аналитика поднимались при загрузке
// страницы — до всякого разрешения, хотя политика уже обещала право отказаться.
// Теперь до ответа не собирается ничего, а ответ можно поменять в любой момент:
// в этом же баннере и в подвале сайта (ссылка «Твои данные»).
//
// Оформление — как у баннера обновления: нижняя полоса, золотая кнопка бренда.

import { useEffect, useState } from 'react';
import { consentAsked, hasConsent, setConsent } from '../instrument';

const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!consentAsked()) setVisible(true);

    // Открыть баннер заново из подвала: window.dispatchEvent(new Event('blotme:privacy'))
    const reopen = () => setVisible(true);
    window.addEventListener('blotme:privacy', reopen);
    return () => window.removeEventListener('blotme:privacy', reopen);
  }, []);

  if (!visible) return null;

  const answer = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 9998,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexWrap: 'wrap', gap: 14,
      padding: '14px 20px',
      background: 'rgba(15, 25, 35, 0.97)',
      borderTop: '1px solid #E8B84B',
      color: '#F5F5F5',
      fontFamily: 'inherit', fontSize: 15, lineHeight: 1.5,
    }}>
      <span style={{ maxWidth: 620 }}>
        Разрешишь присылать нам отчёты о сбоях и обезличенную статистику? Это помогает
        чинить ошибки. Мы не пишем видео и звук и не продаём данные.
        {hasConsent() && <strong style={{ color: '#E8B84B' }}> Сейчас: разрешено.</strong>}
        {consentAsked() && !hasConsent() && <strong style={{ color: '#E8B84B' }}> Сейчас: запрещено.</strong>}
      </span>
      <span style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={() => answer(true)}
          style={{
            padding: '8px 20px', borderRadius: 10, border: 'none', cursor: 'pointer',
            background: '#E8B84B', color: '#131C26', fontWeight: 700, fontSize: 15,
          }}
        >
          Разрешить
        </button>
        <button
          onClick={() => answer(false)}
          style={{
            padding: '8px 20px', borderRadius: 10, cursor: 'pointer',
            background: 'transparent', color: '#F5F5F5', fontSize: 15,
            border: '1px solid rgba(245,245,245,0.35)',
          }}
        >
          Не надо
        </button>
      </span>
    </div>
  );
};

export default ConsentBanner;
